(function () {
	'use strict';

	angular.module('widgets.buyer')
		.service('buyerWidgetsService', buyerWidgetsService);

	function buyerWidgetsService($http, $experiments, URLS, WEEKLY_LOG_ITEM_FIELDS) {
		return {
			getTaskIcons: getTaskIcons,
			getTaskTooltips: getTaskTooltips
		};

		function getTaskIcons() {
			return {
				'None': 'fa fa-plus task-status-none',
				'Open': 'fa fa-circle task-status-open',
				'Fixed': 'fa fa-circle task-status-fixed',
				'Review Later': 'fa fa-circle-o task-status-review-later',
				'Unable to Fix': 'fa fa-circle task-status-unable-to-fix',
				'Expired': 'fa fa-circle task-status-expired'
			};
		}

		function getTaskTooltips() {
			return {
				'Open': 'Task status is Open, click to edit task',
				'Fixed': 'Task status is Fixed, click to edit task',
				'Review Later': 'Task status is In Progress, click to edit task',
				'Unable to Fix': 'Task status is Unable to Fix, click to edit task',
				'None': 'Click to create task'
			};
		}
	}
})();